import { services } from '../api'

const state = {
	testsData: null
}

const getters = {

}

const actions = {
	getTests ({commit}, params) {
		return services.test.getTests(params)
			.then((response) => {
				commit('SET_TESTS_DATA', response.data)
				return response
			})
			.catch((error) => {
				console.error(error)
				commit('SET_TESTS_DATA', null)
				return error.response
			})
	}
}

const mutations = {
	SET_TESTS_DATA (state, tests) {
		state.testsData = tests
	}
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/test.js